import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

import { AuthApi } from './auth-api.interface';
import { logoutResMock } from '../mocks/auth.mock';

@Injectable()
export class AuthApiMockService implements AuthApi {
  logout(): Observable<void> {
    return of(logoutResMock);
  }
}
